import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

// Create axios instance
const api = axios.create({
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Form Submissions
export const submitInquiry = async (inquiryData) => {
  try {
    const response = await api.post(API_ENDPOINTS.createInquiry, inquiryData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const submitQuote = async (quoteData) => {
  try {
    const response = await api.post(API_ENDPOINTS.createQuote, quoteData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Banners
export const getBanners = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.banners);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Services
export const getServices = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.services);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const subscribeNewsletter = (email) =>
  api.post(API_ENDPOINTS.newsletterSubscribe, { email });



export const getServiceById = async (id) => {
  try {
    const response = await api.get(API_ENDPOINTS.getService(id));
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Projects
export const getProjects = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.projects);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};


// Live Gallery
export const getLiveGallery = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.livegallery);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};



export const getLiveGalleryById = async (id) => {
  try {
    const response = await api.get(API_ENDPOINTS.getLiveGalleryImage(id));
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};






export const getProjectById = async (id) => {
  try {
    const response = await api.get(API_ENDPOINTS.getProject(id));
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Blogs
export const getBlogs = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.blogs);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getBlogBySlug = async (slug) => {
  try {
    const response = await api.get(API_ENDPOINTS.getBlog(slug));
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Testimonials
export const getTestimonials = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.testimonials);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Collaborators
export const getCollaborators = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.collaborators);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Gallery
export const getGallery = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.gallery);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// CMS Content
export const getCMSContent = async (slug) => {
  try {
    const response = await api.get(API_ENDPOINTS.getCMS(slug));
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Site Settings
export const getSiteSettings = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.siteSettings);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Site Info
export const getSiteInfo = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.siteInfo);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// News
export const getNews = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.news);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export default api;
